import { ProfileService } from '../profile.service';
import {
  AlertController,
  NavController,
  PopoverController,
  LoadingController,
  ToastController
} from '@ionic/angular';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-settings-popover',
  templateUrl: './settings-popover.component.html',
  styleUrls: ['./settings-popover.component.scss']
})
export class SettingsPopoverComponent implements OnInit {
  currentPopover;

  constructor(
    private router: Router,
    private alertCtrl: AlertController,
    private navCtrl: NavController,
    private popoverCtrl: PopoverController,
    private lodingCtrl: LoadingController,
    private profileService: ProfileService,
    private toastCtrl: ToastController,
    private translocoService: TranslocoService
  ) {}

  ngOnInit() {
    this.popoverCtrl.getTop().then(popover => (this.currentPopover = popover));
  }

  closePopover() {
    if (this.currentPopover) this.currentPopover.dismiss();
    this.currentPopover = null;
  }

  goToPrivacy() {
    this.closePopover();
    this.router.navigateByUrl('policies');
  }

  logout() {
    this.closePopover();
    this.navCtrl.navigateRoot('auth');
  }

  handleDeleteAccount() {
    this.closePopover();
    this.alertCtrl
      .create({
        header: this.translocoService.translate('auth.deleteAccount'),
        message: this.translocoService.translate('auth.deleteAccountMessage'),
        buttons: [
          {
            text: this.translocoService.translate('common.delete'),
            handler: () => {
              this.lodingCtrl.create().then(loader => {
                loader.present();
                this.profileService
                  .deleteAccount()
                  .then(() => {
                    loader.dismiss();
                    this.navCtrl.navigateRoot('auth');
                  })
                  .catch(() => {
                    loader.dismiss();
                    this.toastCtrl
                      .create({
                        message: this.translocoService.translate('auth.deleteAccountError'),
                        duration: 2000,
                        buttons: [
                          {
                            text: this.translocoService.translate('common.close'),
                            role: 'cancel',
                          }
                        ]
                      })
                      .then(toast => toast.present());
                  });
              });
            }
          },
          { text: this.translocoService.translate('common.cancel'), role: 'cancel' }
        ]
      })
      .then(alert => alert.present());
  }
}
